import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const LI = withProps(StyledElement, {
  as: 'li',
  styles: {
    root: styles.li as CSSProp,
  },
});

export default LI;
